/**
 * @generated SignedSource<<1dfb655e982d2595dfd334637b4d3201>>
 * @relayHash 61b0c864f4ac793a8d9ec854f480e261
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 50ab07d34bce5f0d58d834c318c1bb2d66298686f4c390deb34deb3e3718a6f7

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AlertsContentViewQuery$variables = {
  cloudId: string;
};
export type AlertsContentViewQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AlertsMenuItemContent" | "AlertsMenuItemContentNew">;
};
export type AlertsContentViewQuery = {
  response: AlertsContentViewQuery$data;
  variables: AlertsContentViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "kind": "ScalarField",
    "name": "id"
  },
  {
    "kind": "ScalarField",
    "name": "name"
  },
  {
    "kind": "ScalarField",
    "name": "alertSearchQuery"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "AlertsContentViewQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "AlertsMenuItemContentNew"
      },
      {
        "kind": "FragmentSpread",
        "name": "AlertsMenuItemContent"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AlertsContentViewQuery",
    "selections": [
      {
        "concreteType": "OpsgenieQuery",
        "kind": "LinkedField",
        "name": "opsgenie",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
              }
            ],
            "concreteType": "OpsgenieSavedSearches",
            "kind": "LinkedField",
            "name": "savedSearches",
            "plural": false,
            "selections": [
              {
                "concreteType": "OpsgenieSavedSearch",
                "kind": "LinkedField",
                "name": "starred",
                "plural": true,
                "selections": (v1/*: any*/)
              },
              {
                "concreteType": "OpsgenieSavedSearch",
                "kind": "LinkedField",
                "name": "sharedWithMe",
                "plural": true,
                "selections": (v1/*: any*/)
              },
              {
                "concreteType": "OpsgenieSavedSearch",
                "kind": "LinkedField",
                "name": "createdByMe",
                "plural": true,
                "selections": (v1/*: any*/)
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "50ab07d34bce5f0d58d834c318c1bb2d66298686f4c390deb34deb3e3718a6f7",
    "metadata": {},
    "name": "AlertsContentViewQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "879968e67a244943ed377d7fb5da054d";

export default node;
